module.exports = __webpack_public_path__ + "static/media/change-direction.e71de473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/change-direction.svg
// module id = 232
// module chunks = 0